import { Exclude } from "class-transformer";
import { IsBoolean, IsNotEmpty, IsOptional, IsString } from "class-validator";

export class SuccessDto {
    @IsBoolean()
    @IsNotEmpty()
    success: boolean = false;

    @IsString()
    @IsOptional()
    message?: string;

    data?: any;
}

export class HttpErrorDto {
    message: string;

    httpStatus: number;

    @Exclude()
    success: string;

    @Exclude()
    stack: string | undefined;

    @Exclude()
    controller: string | undefined;

    @Exclude()
    methodName: string | undefined;

    @Exclude()
    body: string | undefined;

    @Exclude()
    headers: string | undefined;

    constructor(
        message: string,
        httpStatus: number,
        success = "false",
        stack: string | undefined,
        controller?: string,
        methodName?: string,
        body?: string,
        headers?: string,
    ) {
        this.message = message;
        this.httpStatus = httpStatus;
        this.success = success;
        this.stack = stack;
        this.controller = controller;
        this.methodName = methodName;
        this.body = body;
        this.headers = headers;
    }
}
